<template>
  <div class="user-login">
    <main class="user-login-form">
      <header>
        <img src="../../assets/logo.png" alt="">
        <span>｜音视频通话</span>
      </header>
      <el-form :model="form" :rules="rules" ref="form" v-if="!isLogin">
        <el-form-item prop="userPhoneNum" class="phone-box" v-if="isPhoneMode">
          <el-input class="phone-num" placeholder="电话号码" v-model="form.userPhoneNum">
            <el-input slot="prepend" class="phone-code" v-model="form.preCode" placeholder="区号" />
          </el-input>
        </el-form-item>
        <el-form-item prop="userEmail" v-if="isEmailMode">
          <el-input placeholder="电子邮箱" v-model="form.userEmail">
          </el-input>
        </el-form-item>
        <el-form-item prop="verifyCode">
          <el-input v-model="form.verifyCode"  placeholder="验证码">
          <el-button
            class="user-code-btn"
            slot="append"
            @click="fetchVerifyCode"
            :disabled="disableFetchCodeBtn"
          >{{!disableFetchCodeBtn ? '获取验证码' : (countdown + 's')}}</el-button>
          </el-input>
        </el-form-item>
        <el-form-item>
          <div class="user-declare">
            <el-checkbox v-model="checked" />
            <p>
              我已阅读了
            <el-link type="primary" :href="declare.privacy">《隐私条例》</el-link>
            和
            <el-link type="primary" :href="declare.user">《用户协议》</el-link>
            </p>
          </div>
          <el-button class="user-login-btn" @click="handleLogin('form')" :disabled="!checked">登录</el-button>
        </el-form-item>
      </el-form>
      <div class="user-info" v-else>
        <div class="user-info-avtor">
          <img :src="loginUserInfo.avatar" alt="" srcset=""
        ></div>
        <p class="user-info-name">{{loginUserInfo.name}}</p>
        <footer class="user-info-footer">
          <el-button @click="resetLogin()">进入</el-button>
          <el-button @click="logout()">退出</el-button>
        </footer>
      </div>
      <el-button type="text" @click="handleEquipmentInspection">设备检测</el-button>
      <el-button type="text" @click="switchLoginMode" v-if="!isLogin">切换{{isPhoneMode ? "邮箱" : "手机"}}登录 > </el-button>
    </main>

  </div>
</template>

<script>
import { mapState } from "vuex";
import { getSmsVerifyCode, loginSystemByVerifyCode } from "../../api";
import { isValidatePhoneNum, isValidateEmail, setUserLoginInfo } from "../../utils";

export default {
  name: "Login",
  data() {
    const validatePhone = (rule, value, calback) =>{
      if (this.isEmailMode && !rule.required) {
         calback()
      } else if (value=='') {
        calback(new Error('请输入手机号'));
      } else if (!isValidatePhoneNum(value)) {
        calback(new Error('请输入正确的手机号'));
      } else if (!this.form.preCode) {
        calback(new Error('请输入手机区号'));
      }  else {
        calback()
      }
    }
    const validateEmail = (rule, value, calback) =>{
      if (this.isPhoneMode && !rule.required) {
         calback()
      } else if (value=='') {
        calback(new Error('请输入电子邮箱'));
      } else if (!isValidateEmail(value)) {
        calback(new Error('请输入正确的电子邮箱'));
      } else {
        calback()
      }
    }
    const validateCode = (rule, value, calback) =>{
      if (!rule.required) {
         calback()
      } else if (value=='') {
        calback(new Error('请输入验证码'));
      } else if (!this.verifyCodeInfo) {
        calback(new Error('验证码已失效，请重新获取验证码'));
      } else {
        calback()
      }
    }
    return {
      form: {
        preCode: "86",
        userPhoneNum: "",
        userEmail: "",
        verifyCode: "",
      },
      rules: {
        userPhoneNum: [
          { required: true, validator: validatePhone, trigger: 'blur' }
        ],
        userEmail: [
          { required: true, validator: validateEmail, trigger: 'blur' }
        ],
        verifyCode: [
          { required: true, validator: validateCode, trigger: 'blur' }
        ]
      },
      loginMode: 'phone',
      countdown: 60,
      disableFetchCodeBtn: false,
      timer: null,
      verifyCodeInfo: null,
      declare: {
        privacy: 'https://web.sdk.qcloud.com/document/Tencent-RTC-Privacy-Protection-Guidelines.html',
        user: 'https://web.sdk.qcloud.com/document/Tencent-RTC-User-Agreement.html'
      },
      checked: false
    };
  },
  computed:{
    ...mapState(['isLogin','loginUserInfo','globalServer']),
    isPhoneMode: function () {
      return this.loginMode === 'phone';
    },
    isEmailMode: function () {
      return this.loginMode === 'email';
    }
  },
  destroyed() {
    this.timer && clearInterval(this.timer);
  },
  methods: {
    updateDataByLoginMode(data) {
      this.isPhoneMode
        ? (data.phone = this.form.preCode + this.form.userPhoneNum)
        : (data.email = this.form.userEmail);
      return data;
    },
    // 图片验证成功后发送验证码
    async fetchVerifyCode() {
      if (this.isPhoneMode && !this.handleValidate('form', ['userPhoneNum'])) {
        return
      }
      if (!this.isEmailMode && !this.handleValidate('form', ['userEmail'])) {
        return
      }
      /**
       * 初始化图片校验
       * @param appId 2079625916（前端统一） 
       * 文档地址@alink https://cloud.tencent.com/document/product/1110/36841#pzcs
       */
      const appId = this.globalServer.data.captcha_web_appid;
      const Tcaptcha = new window.TencentCaptcha(appId.toString(), async (res)=>{
        if (res.ret === 0) {
          //图片校验成功发送验证码
          this.disableFetchCodeBtn = true;
          const data = this.updateDataByLoginMode({
            appId,
            ticket: res.ticket,
            randstr: res.randstr
           });
          const response = await getSmsVerifyCode(data);
          if (response.data && response.data.errorCode === 0) {
            this.verifyCodeInfo = response.data.data;
          }
          this.timer = setInterval(()=>{
            this.countdown--;
            if (this.countdown === 0) {
              this.disableFetchCodeBtn = false;
              this.countdown = 60;
              clearInterval(this.timer)
            }
          },1000)
        }
      });
      Tcaptcha.show()
    },
    /**
     * 校验信息
     */
    handleValidate(formName, valiateList) {
      if (valiateList) {
        for (const key in this.rules) {
          this.rules[key][0].required = false
        }
        valiateList.map((val)=>{
          this.rules[val][0].required = true
        })  
      }
      let result = false;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          result = true
        } else {
          result = false;
        }
      });
      if (valiateList) {
        for (const key in this.rules) {
          this.rules[key][0].required = true
        }
      }
      return result;
    },
    //登录
    async handleLogin(formName) {
      if (!this.handleValidate(formName)) {
        return
      }
      const data = this.updateDataByLoginMode({
        sessionId: this.verifyCodeInfo.sessionId,
        code: this.form.verifyCode
      });
      const response = await loginSystemByVerifyCode(data);
      if (response.data && response.data.errorCode === 0) {
        // 登录成功  
        this.$store.commit("userLoginSuccess");
        this.$store.commit("setLoginUserInfo", response.data.data);
        setUserLoginInfo(response.data.data);
        // 登录 trtcCalling
        this.$TRTCCalling.login({
          userID: this.loginUserInfo.userId,
          userSig: this.loginUserInfo.userSig
        });
        this.$router.push('/home')
      } else {
        this.$message.error(response.data.errorMessage);
        // this.disableFetchCodeBtn = false;
      }
    },
    //设备校验
    handleEquipmentInspection() {
        window.open(
          "https://web.sdk.qcloud.com/trtc/webrtc/demo/detect/index.html",
          "__blank"
        );
    },
    //切换手机/邮箱登录
    switchLoginMode() {
      if (this.isPhoneMode) {
        this.loginMode = 'email';
      } else if (this.isEmailMode) {
        this.loginMode = 'phone';
      }
      this.$refs['form'].clearValidate();
    },
    //重新登陆
    resetLogin() {
      this.$router.push('/home')
    },
    //退出
    logout() {
      this.$TRTCCalling.logout();
        this.$store.commit("userLogoutSuccess");
        setUserLoginInfo({
          token: "",
          phoneNum: ""
        });
        this.$router.push("/");
    }
  }
};
</script>

<style scoped>
@import url('./login.css');
</style>
